import React, { Component } from 'react'

//Social Media
import SocialMedia from './SocialMedia';
import footerlogo from '../_img/korg-light.svg'
import bpi from '../_img/bpi.png'
import hsbc from '../_img/hsbc.png'
import paypal from '../_img/paypal.png'
import visa from '../_img/visa.png'
import mastercard from '../_img/mastercard.png'
import gcash from '../_img/gcash.png'

import { postService } from '../_services/post.service';
import { menuService } from '../_services/menu.service';
import { settingsService } from '../_services/settings.service';

export class MainFooter extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
            content: {},
            shopNow: [],
            more: [],
            about: [],
            address: '',
            phone: '',
            mobile: '',
            email: '',
            contactPage: null,
        };
    }


    componentDidMount() {
        menuService.getMenuByName('Shop Now').then(shopNow => this.setState({ shopNow :  shopNow.items}));
        menuService.getMenuByName('About').then(about => this.setState({ about : about.items }));
        menuService.getMenuByName('More').then(more => this.setState({ more : more.items }));
        postService.getSettingsWoo().then(settingAdd => this.setState({address:settingAdd}))
        settingsService.getPages('contact-page').then(pageDetails => this.setState({contactPage:pageDetails}))

    }


    render() {
        const { shopNow, more, about ,address,contactPage } = this.state;
        const branches = this.props.branches
        const getyear = new Date().getFullYear();

        return (
            <div>
                <SocialMedia />
                <footer>
                  <div className="footer-links pt-5 pb-3">
                     <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                               <a href="/"> 
                                 <img  src={footerlogo} alt="" width="120px" />   
                               </a>
                                <br />

                                <address style={{marginTop:"15px"}}>
                                    {address}
                                </address>

                                {
                                    contactPage && contactPage.map((contact, index) => {
                                        // Remove non-numeric characters for the phone and mobile numbers
                                        const formattedPhone = contact.acf.phone.replace(/[^\d+]/g, '');
                                        const formattedMobile = contact.acf.mobile.replace(/[^\d+]/g, '');
                                        
                                        return (
                                            <address key={index} style={{ display: 'inline-grid' }}>
                                                <br />
                                                <span className="d-flex">
                                                    <strong>PHONE:&nbsp;</strong>
                                                    <a href={`tel:${formattedPhone}`}> {contact.acf.phone}</a>
                                                </span>
                                                <span className="d-flex">
                                                    <strong>MOBILE:&nbsp;</strong>
                                                    <a href={`tel:${formattedMobile}`}> {contact.acf.mobile}</a>
                                                </span>
                                                <span className="d-flex">
                                                    <strong>EMAIL:&nbsp;</strong>
                                                    <a href={`mailto:${contact.acf.email}`}> {contact.acf.email}</a>
                                                </span>
                                            </address>
                                        );
                                    })
                                }

                                

                            </div>

                             <div className="col-md-2">
                                <h4>SHOP NOW</h4>
                                    <ul className="list-unstyled">
                                    {shopNow && shopNow.map((menu, index) =>
                                        <li className="nav-item" key={index} >
                                            <a className="nav-link" href={menu.url}  style={{padding:'0'}}> 
                                                { menu.title } 
                                            </a>
                                            
                                        </li>    
                                    )}
                                    </ul>
                             </div>

                                <div className="col-md-2">
                                    <h4>MORE</h4>
                                    <ul className="list-unstyled">
                                        {more && more.map((menu, index) =>
                                            <li className="nav-item" key={index} >
                                                <a className="nav-link" href={menu.url} style={{padding:'0'}}> 
                                                    { menu.title } 
                                                </a>
                                                
                                            </li>    
                                        )}
                                     </ul>
                                </div>

                                <div className="col-md-2">
                                    <h4>ABOUT</h4>
                                    <ul className="list-unstyled">
                                        {about && about.map((menu, index) => (
                                                <li className="nav-item" key={index}>
                                                    <a className="nav-link" href={menu.url}  style={{padding:'0'}}>
                                                        {menu.title}
                                                    </a>
                                                </li>
                                            ))}
                                    </ul>
                                </div>

                                    <div className="col-md-3">
                                        <h4>BRANCHES</h4>
                                    <ul className="list-unstyled">
                                    { branches && Array.isArray(branches) && branches.map((store =>
                                             <li key={store.id}>
                                                <address>
                                                    <strong> 
                                                        {store.acf.address1 && store.acf.city && store.acf.state && store.acf.country && (
                                                            <a href={store.acf.mapurl} dangerouslySetInnerHTML={{ __html: store.title.rendered }} />
                                                        )}
                                                    </strong> 
                                                        <a href={`tel:${store.acf.phone}`}>{store.acf.phone} </a>
                                                </address>
                                             </li>
                                     ))
                                     }
                                        </ul>
                                    </div>
                                </div>

                                <div className="row copyright">
                                    <div className="col-sm-12 col-md-12 col-lg-6 py-lg-3 " > 
                                        <p className="pt-3 pb-1">Copyright &copy; { getyear } Music & Audio Solutions & Services Inc. All rights reserved.</p>
                                    </div>
                                    <div className="col-sm-12 col-md-12 col-lg-6 pt-lg-3 text-center text-md-left">
                                            <img className="mr-3 pb-3" src={bpi} alt="BPI" />
                                            <img className="mr-3 pb-3" src={hsbc} alt="HSBC" />
                                            <img className="mr-3 pb-3" src={paypal} alt="PayPal" />
                                            <img className="mr-3 pb-3" src={visa} alt="VISA" />
                                            <img className="mr-3 pb-3" src={mastercard} alt="Master Card" />
                                            <img className="mr-3 pb-3" src={gcash} alt="GCash" />
                                    </div>
                                </div>										
                            </div>
                    </div>
                </footer>
            </div>
           
        )
    }
}

export default MainFooter
